import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Injectable, Inject, PLATFORM_ID, Output, afterNextRender } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from 'rxjs';
import { environment } from "../../../environments/environment";
//import { LanguageNotAvailableDialogComponent } from "../language-not-available-dialog/language-not-available-dialog.component";

@Injectable({
  providedIn: "root",
})
export class ExdrLanguageService {

  showLanguageSwitch = new BehaviorSubject<boolean>(true);
  currentLanguage: LanguageModel | null = null;
  get preferredLanguage(): LanguageModel {
    if(isPlatformBrowser(this.platformId)){
      return localStorage.getItem("preferredLanguage") ? JSON.parse(localStorage.getItem("preferredLanguage") as string) : null;
    }
    return null;
  }
  set preferredLanguage(lang: LanguageModel) {
    if (lang) {
      afterNextRender(()=>{
        localStorage.setItem('preferredLanguage', JSON.stringify(lang));
      })      
    }
  }  
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private _translate: TranslateService,
    private _matDialog: MatDialog,
    ) { }



  setCurrentLocale(locale: string, isPreferred: boolean = false) {
    if (isPlatformBrowser(this.platformId)) {
      const selectedLang = Languages.find((l) => l.locale == locale);
      if (selectedLang) {
        if (isPreferred) {
          this.preferredLanguage = selectedLang;
        }
        if (this.currentLanguage?.locale == selectedLang.locale) {
          return;
        }

        this.currentLanguage = selectedLang;
        this.setFontFamily(this.currentLanguage.locale)

        const body = document.getElementsByTagName("body")[0];
        if (selectedLang.isRtl) {
          body.classList.add("rtl");
        } else {
          body.classList.remove("rtl");
        }
        this._translate.use(selectedLang.locale);
      }
    }
  }

  initializeLanguage(groupId?: string, availableLocales: string[] = [], defaultLocale = null)//: MatDialogRef<LanguageNotAvailableDialogComponent, any> 
  {
    if (groupId) {
      if (!availableLocales.length) {
        availableLocales.push(environment.defaultLocale);
      }
      if (this.preferredLanguage) {
        if (availableLocales.includes(this.preferredLanguage?.locale)) {
          this.setCurrentLocale(this.preferredLanguage?.locale);
        } else {
          //return this.languageNotAvailabeDialog(defaultLocale || environment.defaultLocale);
        }
      } else {
        if (defaultLocale && availableLocales.includes(defaultLocale)) {
          this.setCurrentLocale(defaultLocale);
        } else {
          this.setCurrentLocale(environment.defaultLocale);
        }
      }
    } else {
      this.setCurrentLocale(this.preferredLanguage?.locale || environment.defaultLocale);
    }

  }

  // private languageNotAvailabeDialog(localeToSet: string): MatDialogRef<LanguageNotAvailableDialogComponent, any> {
  //   const returnStageDialogRef = this._matDialog.open(LanguageNotAvailableDialogComponent, {
  //     width: '552px',
  //     autoFocus: false,
  //     direction: this.preferredLanguage.isRtl ? 'rtl' : 'ltr',
  //     data: {
  //       lang: this.preferredLanguage.name
  //     }
  //   });
  //   returnStageDialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.setCurrentLocale(localeToSet, true);
  //     }
  //   });
  //   return returnStageDialogRef;
  // }

  private setFontFamily(locale: string) {
    if (!document) { return; }
    let fontFamily = 'var(--xcdr-english-font), var(--xcdr-arabic-font), "Helvetica Neue", sans-serif'
    if (locale == 'ar') {
      fontFamily = 'var(--xcdr-arabic-font), var(--xcdr-english-font), "Helvetica Neue", sans-serif'
    }
    document.documentElement.style.setProperty("--xcdr-font-family", fontFamily);
  }
}

export interface LanguageModel {
  name: string;
  locale: string;
  isRtl: boolean;
}

export const Languages: LanguageModel[] = [
  {
    name: "English",
    locale: "en",
    isRtl: false,
  },
  {
    name: "العربية",
    locale: "ar",
    isRtl: true,
  },
  {
    name: "Français",
    locale: "fr",
    isRtl: false,
  },
];
